import {
    clearNotificationVariables,
    setNotificationVariable,
} from "@repo/guide-core-helpers";
import {randomUUID} from "@repo/util-random-uuid";

import type {Notification, NotificationStyle} from "../types.ts";

interface NotificationHideAction {
    type: "HIDE";
}

interface NotificationShowAction {
    type: "SHOW";
    style: NotificationStyle;
    notification: Notification;
    eventName: string;
}

export type NotificationAction =
    | NotificationHideAction
    | NotificationShowAction;

export type NotificationState =
    | {
          isShowing: true;
          notificationId: string;
          notification: Readonly<Notification>;
          style: NotificationStyle;
          eventName: string;
      }
    | {
          isShowing: false;
      };

export const initialState: NotificationState = {
    isShowing: false,
};

export const notificationReducer = (
    state: NotificationState,
    action: NotificationAction,
): NotificationState => {
    switch (action.type) {
        case "SHOW":
            const notificationId = randomUUID();
            setNotificationVariable("notificationID", notificationId);
            return {
                isShowing: true,
                notificationId,
                notification: action.notification,
                style: action.style,
                eventName: action.eventName,
            };
        case "HIDE":
            clearNotificationVariables();
            return {isShowing: false};
        default:
            return state;
    }
};
